import Keycloak from 'keycloak-js'

let KEYCLOAK_INSTANCE = null

const connectKeycloak = async ({ url, realm, clientId, refreshInSeconds = 30 } = {}) => {
    const keycloakConfig = {
        url,
        realm,
        clientId
    }

    KEYCLOAK_INSTANCE = new Keycloak(keycloakConfig)

    /** @type {import('keycloak-js').KeycloakInitOptions} */
    const initOptions = {
        onLoad: 'login-required',
        useNonce: true,
        checkLoginIframe: false,
        pkceMethod: 'S256'
    }

    return KEYCLOAK_INSTANCE.init(initOptions)
    .then(authenticated => {
        setInterval(() => {
            if (KEYCLOAK_INSTANCE.authenticated) {
                KEYCLOAK_INSTANCE.updateToken(900)
                .catch(() => {
                    KEYCLOAK_INSTANCE.logout()
                })
            }
        }, refreshInSeconds * 1000)

        if (!authenticated) {
            throw 'kc-connection-failed'
        }

        return KEYCLOAK_INSTANCE
    })
    .catch(() => {
        // just returns 'true' as err value
        throw 'kc-init-error'
    })
}

const useKeycloak = () => {
    if (!KEYCLOAK_INSTANCE) {
        throw 'connectKeycloak() needs to be called first'
    }

    return KEYCLOAK_INSTANCE
}

export {
    connectKeycloak,
    useKeycloak
}
